import React from "react";
import { Button, Box, Group } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { TimePeriod } from "types/analyticsTypes";

interface TimePeriodSelectorProps {
  value: TimePeriod;
  onChange: (period: TimePeriod) => void;
  style?: React.CSSProperties;
}

const TimePeriodSelector: React.FC<TimePeriodSelectorProps> = ({ value, onChange, style }) => {
  const { t } = useTranslation();

  const handleClick = (period: TimePeriod) => {
    onChange(period);
  };
  const buttonVariant = "default";
  const activeVariant = "filled";

  return (
    <Box style={style}>
      <Group align={"flex-end"}>
        <Button.Group>
          <Button
            variant={value === TimePeriod.WEEK ? activeVariant : buttonVariant}
            onClick={() => handleClick(TimePeriod.WEEK)}
          >
            {t("analytics.common.testCounts.last7DaysLabel")}
          </Button>
          <Button
            variant={value === TimePeriod.MONTH ? activeVariant : buttonVariant}
            onClick={() => handleClick(TimePeriod.MONTH)}
          >
            {t("analytics.common.testCounts.last30DaysLabel")}
          </Button>
          <Button
            variant={value === TimePeriod.QUARTER ? activeVariant : buttonVariant}
            onClick={() => handleClick(TimePeriod.QUARTER)}
          >
            {t("analytics.common.testCounts.last90DaysLabel")}
          </Button>
          <Button
            variant={value === TimePeriod.YEAR ? activeVariant : buttonVariant}
            onClick={() => handleClick(TimePeriod.YEAR)}
          >
            {t("analytics.common.testCounts.last365DaysLabel")}
          </Button>
          <Button
            variant={value === TimePeriod.ALL ? activeVariant : buttonVariant}
            onClick={() => handleClick(TimePeriod.ALL)}
          >
            {t("analytics.common.testCounts.allLabel")}
          </Button>
        </Button.Group>
      </Group>
    </Box>
  );
};

export default TimePeriodSelector;
